import { render } from "./App.vue?vue&type=template&id=35216a26"
import script from "./App.vue.ts?vue&type=script&lang=ts"
export * from "./App.vue.ts?vue&type=script&lang=ts"
script.render = render

export default script